export default __webpack_public_path__ + "static/NotVeryConfident-db4f8aba4852859381b183757c59b3e8.svg";